import { computed } from "vue";
import { useBreakpoint } from "./useBreakpoint";

export function useUIControls() {
  // 使用断点composable
  const { breakpointSwitch } = useBreakpoint();

  const textContentStyles = computed(() => {
    return breakpointSwitch({
      xs: () => "text-xs",
      sm: () => "text-sm",
      md: () => "text-sm",
      lg: () => "text-sm",
      xl: () => "text-sm",
      "2xl": () => "text-sm",
      default: () => "text-xs",
    });
  });

  // 使用useBreakpoint计算响应式样式
  const toolbarStyles = computed(() => {
    const baseStyles = "bg-base-100 p-2 rounded-lg shadow-lg z-40 flex gap-2";

    return breakpointSwitch({
      xs: () => `${baseStyles} `,
      sm: () =>
        `${baseStyles} fixed left-4 top-1/2 -translate-y-1/2 flex-col h-fit`,
      md: () =>
        `${baseStyles} fixed left-4 top-1/2 -translate-y-1/2 flex-col h-fit`,
      lg: () =>
        `${baseStyles} fixed left-4 top-1/2 -translate-y-1/2 flex-col h-fit`,
      xl: () =>
        `${baseStyles} fixed left-4 top-1/2 -translate-y-1/2 flex-col h-fit`,
      "2xl": () =>
        `${baseStyles} fixed left-4 top-1/2 -translate-y-1/2 flex-col h-fit`,
      default: () => `${baseStyles}`,
    });
  });

  // 响应式样式计算属性
  const controlButtonsStyles = computed(() => {
    const baseStyles = "flex gap-4 justify-center items-end z-10";
    return breakpointSwitch({
      xs: () => `${baseStyles} bottom-24`,
      sm: () => `${baseStyles} bottom-2`,
      md: () => `${baseStyles} bottom-2`,
      lg: () => `${baseStyles} bottom-2`,
      xl: () => `${baseStyles} bottom-2`,
      "2xl": () => `${baseStyles} bottom-2`,
      default: () => `${baseStyles} bottom-20`,
    });
  });

  // 响应式样式计算属性
  const buttonsStyles = computed(() => {
    const baseStyles = "btn";
    return breakpointSwitch({
      xs: () => `${baseStyles} btn-xs`,
      sm: () => `${baseStyles} btn-sm`,
      md: () => `${baseStyles} btn-sm`,
      lg: () => `${baseStyles} btn-sm`,
      xl: () => `${baseStyles} btn-sm`,
      "2xl": () => `${baseStyles} btn-sm`,
      default: () => `${baseStyles} btn-xs`,
    });
  });

  // 添加响应式按钮大小计算属性
  const sideButtonStyles = computed(() => {
    return breakpointSwitch({
      xs: () => "w-12 h-12",
      sm: () => "w-10 h-10",
      md: () => "w-12 h-12",
      lg: () => "w-14 h-14",
      xl: () => "w-14 h-14",
      "2xl": () => "w-14 h-14",
      default: () => "w-12 h-12",
    });
  });

  const mainButtonStyles = computed(() => {
    return breakpointSwitch({
      xs: () => "btn btn-circle btn-primary w-14 h-14",
      sm: () => "btn btn-circle btn-primary w-16 h-16",
      md: () => "btn btn-circle btn-primary w-16 h-16",
      lg: () => "btn btn-circle btn-primary w-16 h-16",
      xl: () => "btn btn-circle btn-primary w-16 h-16",
      "2xl": () => "btn btn-circle  btn-primary w-16 h-16",
      default: () => "btn btn-xs btn-circle  btn-primary w-12 h-12",
    });
  });

  const sideIconSize = computed(() => {
    return breakpointSwitch({
      xs: () => "text-xl",
      sm: () => "text-2xl",
      md: () => "text-2xl",
      lg: () => "text-2xl",
      xl: () => "text-2xl",
      "2xl": () => "text-2xl",
      default: () => "text-xl",
    });
  });

  const mainIconSize = computed(() => {
    return breakpointSwitch({
      xs: () => "text-xl",
      sm: () => "text-2xl",
      md: () => "text-2xl",
      lg: () => "text-2xl",
      xl: () => "text-2xl",
      "2xl": () => "text-2xl",
      default: () => "text-sm",
    });
  });

  return {
    // 样式计算属性
    controlButtonsStyles,
    sideButtonStyles,
    mainButtonStyles,
    sideIconSize,
    mainIconSize,
    textContentStyles,
    toolbarStyles,
    buttonsStyles,
  };
}

/**
 * Composable for responsive canvas container styles
 * Provides consistent responsive styling for canvas containers across components
 */
export function useResponsiveCanvasStyles() {
  const { breakpointSwitch } = useBreakpoint();

  /**
   * Get responsive styles for any container based on breakpoints
   * @param baseStyles - Base CSS classes to apply to all breakpoints
   * @returns Computed property with responsive styles
   */
  const getResponsiveStyles = () => {
    const baseStyles =
      "bg-base-200 flex justify-center overflow-hidden select-none";

    return computed(() => {
      return breakpointSwitch({
        xs: () => `${baseStyles} min-w-[400px] max-h-[400px] `,
        sm: () => `${baseStyles} min-w-[640px] max-h-[500px] `,
        md: () => `${baseStyles} min-w-[768px] max-h-[500px]`,
        lg: () => `${baseStyles} min-w-[1024px] max-h-[540px]`,
        xl: () => `${baseStyles} min-w-[1280px]  max-h-[640px]`,
        "2xl": () => `${baseStyles}  min-w-[1536px] max-h-[640px]`,
        default: () => `${baseStyles} min-w-[320px] max-h-[400px]`,
      });
    });
  };

  return {
    getResponsiveStyles,
  };
}
